import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';

import Navbar from './layouts/Navbar.js';
import Footer from './layouts/Footer.js';

import '../assets/css/Service.css';
import '../assets/css/components/Slider.css';

import solutionImgKor from '../assets/img/ASTRONAV_04_kor.png';
import solutionImgEng from '../assets/img/ASTRONAV_04_eng.png';
import astronavOverviewImgKor from '../assets/img/ASTRONAV_01_kor.png';
import astronavOverviewImgEng from '../assets/img/ASTRONAV_01_eng.png';
import astronavOverviewDetailImgKor from '../assets/img/ASTRONAV_02_kor.png';
import astronavOverviewDetailImgEng from '../assets/img/ASTRONAV_02_eng.png';
import astronavTechnologyImgKor from '../assets/img/ASTRONAV_03_kor.png';
import astronavTechnologyImgEng from '../assets/img/ASTRONAV_03_eng.png';
import nidays2026Img1 from '../assets/img/NIDAYS2026_01.jpg';
import nidays2026Img2 from '../assets/img/NIDAYS2026_02.jpg';
import nidays2026Img3 from '../assets/img/NIDAYS2026_03.jpg';
import nidays2026Img4 from '../assets/img/NIDAYS2026_04.jpg';

export default function UAMSimulatorKorean() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const lang = localStorage.getItem('lang') || 'ko';
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [i18n]);

  const isKorean = (i18n.language || 'ko').startsWith('ko');
  const solutionImg = isKorean ? solutionImgKor : solutionImgEng;
  const astronavOverviewImg = isKorean ? astronavOverviewImgKor : astronavOverviewImgEng;
  const astronavOverviewDetailImg = isKorean ? astronavOverviewDetailImgKor : astronavOverviewDetailImgEng;
  const astronavTechnologyImg = isKorean ? astronavTechnologyImgKor : astronavTechnologyImgEng;

  const settingsExhibition = {
    centerMode: true,
    slidesToShow: 3,
    dots: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3500,
    responsive: [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          dots: false
        }
      },
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          dots: true
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          dots: true
        }
      }
    ]
  };

  return (
    <>
      <Navbar />
      <div className="wrapper">
        <div id="UAMHeader" className="Hero">
          <div className="HeaderSection fadeDivide">
            <div className="HeaderSectionTxtBox">
              <div className="HeaderSectionSubTitle">{t('UAM')}</div>
              <div className="HeaderSectionTitle">ASTRONAV</div>
              <div className="HeaderSectionTxt">
                {isKorean
                  ? 'ASTRONAV는 한국의 실시간 항법시뮬레이션 기술, 프랑스의 GNSS 시뮬레이터 기술, 그리고 미국 NI의 확장형 실시간 하드웨어가 결합된 국제 공동개발 항공우주 GNC 시뮬레이션 솔루션입니다.'
                  : 'ASTRONAV is an internationally co-developed aerospace GNC simulation solution that combines Korea\'s real-time navigation simulation technology, France\'s GNSS simulator technology, and NI\'s scalable real-time hardware from the United States.'}
              </div>
            </div>
          </div>
        </div>

        <div id="Overview_ASTRONAV">
          <div className="Section">
            <div className="SectionHeaderFull">
              <div className="SectionHeaderTxtbox">
                <div className="SectionHeaderCategory CategoryDark fadeDivide">Overview</div>
                <div className="SectionHeaderTitle fadeDivide" style={{ lineHeight: '50px', marginBottom: '24px' }}>
                  <span className="SectionHeaderTitleMain">ASTRONAV</span>
                  <br />
                  <span className="SectionHeaderTitleDesc">
                    {isKorean
                      ? 'ASTRONAV는 한국의 실시간 항법시뮬레이션 기술, 프랑스의 GNSS 시뮬레이터 기술, 그리고 미국 NI의 확장형 실시간 하드웨어가 결합된 국제 공동개발 항공우주 GNC 시뮬레이션 솔루션입니다.'
                      : 'ASTRONAV is an internationally co-developed aerospace GNC simulation solution that combines Korea\'s real-time navigation simulation technology, France\'s GNSS simulator technology, and NI\'s scalable real-time hardware from the United States.'}
                  </span>
                </div>
                <div className="SectionHeaderDescription fadeDivide" style={{ maxWidth: '980px', marginBottom: '28px' }}>
                  {isKorean
                    ? 'GNSS, IMU, 6DoF 비행운동 시뮬레이션을 하나의 실시간 플랫폼으로 통합하여 항공우주비행체의 항법·유도·제어 시스템 개발과 시험을 지원합니다.'
                    : 'It integrates GNSS, IMU, and 6DoF flight-dynamics simulation into a single real-time platform, supporting the development and testing of navigation, guidance, and control systems for aerospace vehicles.'}
                </div>
              </div>
            </div>

            <div className="SectionContents" style={{ maxWidth: '1100px', margin: '0 auto' }}>
              <div className="astronavIntroSplit fadeDivide">
                <div className="SectionHeaderDescription astronavBodyDark" style={{ fontSize: '18px', lineHeight: '34px' }}>
                  <p>
                    {isKorean
                      ? 'ASTRONAV는 항공우주비행체의 항법·유도·제어(GNC, Guidance·Navigation·Control) 시스템 개발과 검증을 위한 실시간 GNSS/IMU 통합 시뮬레이션 장비입니다. GNSS 신호, 관성센서(IMU), 비행운동 정보를 통합적으로 재현하여 발사체, 드론, UAV, 방산 시스템 등 다양한 항공우주 응용 분야의 HILS(Hardware-in-the-Loop Simulation) 시험 환경을 제공합니다.'
                      : 'ASTRONAV is a real-time GNSS/IMU integrated simulation platform for developing and validating aerospace GNC systems. It reproduces GNSS signals, IMU data, and flight dynamics to provide HILS test environments for launch vehicles, drones, UAVs, and defense applications.'}
                  </p>
                  <p>
                    {isKorean
                      ? '기존 HILS 시험 환경은 높은 장비 가격, 복잡한 구축 절차, 제한적인 실환경 재현, 낮은 확장성 등의 한계를 가지고 있습니다. ASTRONAV는 이러한 문제를 해결하기 위해 GUI 기반의 직관적인 설정 환경, GNSS·IMU·6DoF 통합 실시간 시뮬레이션, 모듈형 확장 하드웨어 구조를 제공하며, 보다 빠르고 효율적인 시험 환경을 구현합니다.'
                      : 'Conventional HILS environments often face high equipment cost, complex setup, limited realism, and low scalability. ASTRONAV addresses these limits with GUI-based configuration, integrated GNSS/IMU/6DoF real-time simulation, and modular expandable hardware.'}
                  </p>
                  <p>
                    {isKorean
                      ? 'ASTRONAV는 단순한 연구개발용 시험 장비를 넘어, 실제 고객의 검증 환경에 적용 가능한 현장 실증형 GNC 시뮬레이터를 지향합니다. 이를 통해 항공우주 시스템 개발 과정에서 요구되는 시험 효율성, 현실성, 확장성을 동시에 확보할 수 있습니다.'
                      : 'Beyond an R&D bench, ASTRONAV targets field-proven validation environments that can be applied to real customer workflows, improving efficiency, realism, and scalability together.'}
                  </p>
                </div>
                <div className="astronavOverviewImageWrap">
                  <img className="astronavOverviewImage" src={astronavOverviewImg} alt="ASTRONAV Overview" />
                </div>
              </div>

              <div className="fadeDivide" style={{ marginTop: '30px' }}>
                <img className="astronavOverviewDetailImage" src={astronavOverviewDetailImg} alt="ASTRONAV Overview Detail" />
              </div>
            </div>
          </div>
        </div>

        <div id="Technology_ASTRONAV">
          <div className="Section">
            <div className="SectionHeaderFull">
              <div className="SectionHeaderTxtbox">
                <div className="SectionHeaderCategory CategoryBright fadeDivide">Technology</div>
                <div className="SectionHeaderTitle whiteFonts fadeDivide" style={{ lineHeight: '50px' }}>
                  <span>
                    {isKorean
                      ? 'ASTRONAV는 실제 비행환경에 가까운 정밀한 가상 시험 환경을 구현하기 위한 시뮬레이션 솔루션입니다.'
                      : 'A simulation solution designed to build realistic virtual flight test environments.'}
                  </span>
                </div>
                <div className="SectionHeaderDescription whiteFonts fadeDivide" style={{ maxWidth: '980px', marginTop: '24px', marginBottom: '24px' }}>
                  {isKorean
                    ? 'GNSS 신호 생성, IMU 시뮬레이션, 6DoF 비행운동 재현 기술을 하나의 실시간 플랫폼으로 통합하여 실제 비행환경에 가까운 가상 시험 환경 구성과 항공우주비행체의 항법·유도·제어 시스템 개발 및 시험을 지원합니다.'
                    : 'Based on GNSS generation, IMU simulation, and 6DoF dynamics with GUI and NI PXI modular architecture.'}
                </div>
              </div>
            </div>

            <div className="SectionContents" style={{ maxWidth: '1100px', margin: '0 auto' }}>
              <div className="astronavTechSplit fadeDivide">
                <div className="SectionHeaderDescription astronavBodyLight" style={{ fontSize: '18px', lineHeight: '34px' }}>
                  <p className="astronavItemTitle">{isKorean ? '1) GNSS/IMU 통합 시뮬레이션' : '1) GNSS/IMU Integrated Simulation'}</p>
                  <p>
                    {isKorean
                      ? 'ASTRONAV는 GNSS 신호 생성과 IMU 데이터 시뮬레이션을 통합 제공함으로써, 복합항법 시스템이 실제 운용 조건에서 수행해야 하는 위치·속도·자세 추정 과정을 보다 현실적으로 검증할 수 있도록 설계되었습니다.'
                      : 'Integrated GNSS signal and IMU data simulation enables realistic verification of integrated navigation estimation.'}
                  </p>
                  <p className="astronavItemTitle">{isKorean ? '2) 6DoF 운동 시뮬레이션' : '2) 6DoF Motion Simulation'}</p>
                  <p>
                    {isKorean
                      ? '6자유도 비행운동 시뮬레이션으로 항공우주비행체의 자세 변화와 동적 거동을 반영하며, 실제 비행조건에 가까운 환경에서 GNC 알고리즘의 안정성·응답성·제어 성능을 검증합니다.'
                      : '6DoF simulation reflects real attitude and dynamics for robust GNC stability and control verification.'}
                  </p>
                  <p className="astronavItemTitle">{isKorean ? '3) GUI 기반 실시간 설정 환경' : '3) GUI-based Real-time Configuration'}</p>
                  <p>
                    {isKorean
                      ? 'GUI 기반 설정 환경을 제공하여 소스코드 중심 시험 구성보다 빠르고 직관적인 시험 구성이 가능합니다.'
                      : 'GUI-based workflow enables faster and more intuitive test setup than code-centric workflows.'}
                  </p>
                  <p className="astronavItemTitle">{isKorean ? '4) NI PXI 기반 확장형 하드웨어' : '4) NI PXI-based Modular Hardware'}</p>
                  <p>
                    {isKorean
                      ? '모듈형 하드웨어 플랫폼을 통해 고객 요구에 따라 인터페이스 추가 및 시험 환경 확장이 가능합니다.'
                      : 'Modular NI PXI hardware supports interface expansion and scalable test environments.'}
                  </p>
                  <p className="astronavItemTitle">{isKorean ? '5) 현장 적용 가능한 기술 성숙도' : '5) Field-ready Technology Maturity'}</p>
                  <p>
                    {isKorean
                      ? '핵심 모듈은 시제품 단계에 도달했으며 일부 모듈은 실제 납품·현장 적용 검증이 진행 중입니다.'
                      : 'Key modules have reached prototype stage and are being validated through real deployment.'}
                  </p>
                </div>
                <div className="astronavTechImageWrap">
                  <img className="astronavTechImage" src={astronavTechnologyImg} alt="ASTRONAV Technology" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="Features_ASTRONAV">
          <div className="Section">
            <div className="SectionHeaderFull">
              <div className="SectionHeaderTxtbox">
                <div className="SectionHeaderCategory CategoryDark fadeDivide">Features</div>
                <div className="SectionHeaderTitle fadeDivide" style={{ lineHeight: '50px' }}>
                  <span>
                    {isKorean
                      ? 'ASTRONAV는 고객이 실제 시험 환경에서 겪는 문제를 해결하기 위해  설계되었습니다.'
                      : 'ASTRONAV is designed to solve the problems customers face in real test environments.'}
                  </span>
                </div>
                <div className="SectionHeaderDescription fadeDivide" style={{ maxWidth: '980px', marginTop: '24px', marginBottom: '24px' }}>
                  {isKorean
                    ? 'ASTRONAV는 빠른 HILS 구축, 통합 실시간 시뮬레이션, 실제 비행환경 재현, 확장형 하드웨어 구조를 통해 고객의 시험 효율성과 검증 신뢰성을 높이는 실용형 GNC 시뮬레이터입니다. ASTRONAV는 단순히 시뮬레이션 장비가 아니라, 실제 항공우주 시험 환경에서 요구되는 빠른 구축, 현실적인 검증, 유연한 확장성, 합리적인 도입 구조를 함께 제공하는 통합 검증 솔루션입니다.'
                    : 'ASTRONAV is a practical GNC simulator that improves test efficiency and validation reliability through rapid HILS setup, integrated real-time simulation, realistic flight-environment reproduction, and a scalable hardware architecture. Rather than being just a simulation device, ASTRONAV is an integrated validation solution that also provides fast deployment, realistic verification, flexible scalability, and a cost-effective adoption structure required in real aerospace test environments.'}
                </div>
              </div>
            </div>

            <div className="SectionContents" style={{ maxWidth: '1100px', margin: '0 auto' }}>
              <div className="SectionHeaderDescription astronavBodyDark fadeDivide" style={{ fontSize: '18px', lineHeight: '34px' }}>
                <p className="astronavFeatureItemTitle">{isKorean ? '1) GUI 기반의 빠른 HILS 구축' : '1) Fast GUI-based HILS Setup'}</p>
                <p>{isKorean ? '복잡한 소스코드 수정 없이 GUI에서 주요 설정을 빠르게 구성할 수 있어 HILS 구축 시간을 단축합니다.' : 'Quick setup in GUI without complex source-code modifications reduces HILS build time.'}</p>

                <p className="astronavFeatureItemTitle">{isKorean ? '2) 비전문가도 쉽게 설정 가능한 사용자 중심 인터페이스' : '2) User-centric Interface for Non-experts'}</p>
                <p>{isKorean ? '숙련된 개발자가 아니어도 시험 시나리오와 장비 설정을 직관적으로 수행할 수 있습니다.' : 'Even non-experts can intuitively configure scenarios and equipment settings.'}</p>

                <p className="astronavFeatureItemTitle">{isKorean ? '3) GNSS·IMU·6DoF를 통합한 실시간 시뮬레이션' : '3) Integrated Real-time Simulation of GNSS/IMU/6DoF'}</p>
                <p>{isKorean ? '위성항법, 관성센서, 6자유도 운동을 하나의 플랫폼에서 동시에 실시간으로 시뮬레이션합니다.' : 'Simulates satellite navigation, IMU, and 6DoF dynamics simultaneously in real time on one platform.'}</p>

                <p className="astronavFeatureItemTitle">{isKorean ? '4) 항법·유도·제어 시험을 위한 통합 실시간 검증 환경 제공' : '4) Integrated Real-time Validation for GNC Testing'}</p>
                <p>{isKorean ? '항공우주비행체의 GNC 시스템을 실제 운용에 가깝게 통합 검증할 수 있는 시험환경을 제공합니다.' : 'Provides an integrated validation environment close to real operation for aerospace GNC systems.'}</p>

                <p className="astronavFeatureItemTitle">{isKorean ? '5) 실제 비행환경을 반영한 고충실도 시나리오 재현' : '5) High-fidelity Scenario Reproduction'}</p>
                <p>{isKorean ? '다양한 비행 조건과 동적 환경을 반영하여 실제 비행과 유사한 시험 조건을 구현합니다.' : 'Implements flight-like test conditions by reflecting diverse flight and dynamic environments.'}</p>

                <p className="astronavFeatureItemTitle">{isKorean ? '6) 발사체·드론·항공우주비행체용 가상 비행환경 구현' : '6) Virtual Flight Environments for Multiple Vehicles'}</p>
                <p>{isKorean ? '소형발사체, 드론, 유도무기 등 다양한 이동체에 적용 가능한 가상 시험환경을 제공합니다.' : 'Provides virtual test environments for launch vehicles, drones, and other aerospace systems.'}</p>

                <p className="astronavFeatureItemTitle">{isKorean ? '7) 실시간 운동 및 센서 연동 기반의 HILS 시험 지원' : '7) HILS Support with Real-time Dynamics and Sensor Coupling'}</p>
                <p>{isKorean ? '실제 장비와 시뮬레이터를 연동하여 센서 입력과 비행 운동을 실시간으로 검증할 수 있습니다.' : 'Enables real-time validation of sensor inputs and flight dynamics by coupling hardware and simulator.'}</p>

                <p className="astronavFeatureItemTitle">{isKorean ? '8) 모듈형 구조를 적용한 확장형 하드웨어 아키텍처' : '8) Scalable Hardware with Modular Architecture'}</p>
                <p>{isKorean ? '기능별 모듈 구조로 설계되어 시스템 변경이나 기능 추가가 용이합니다.' : 'Function-based modular architecture makes changes and feature additions easy.'}</p>

                <p className="astronavFeatureItemTitle">{isKorean ? '9) NI PXI 기반의 유연한 인터페이스 확장 지원' : '9) Flexible Interface Expansion with NI PXI'}</p>
                <p>{isKorean ? 'NI PXI 플랫폼을 활용하여 다양한 입출력 장치와 인터페이스를 손쉽게 확장할 수 있습니다.' : 'Supports easy expansion of diverse I/O devices and interfaces using NI PXI.'}</p>

                <p className="astronavFeatureItemTitle">{isKorean ? '10) 시험 대상 및 운용 요구에 따라 손쉽게 확장 가능한 플랫폼' : '10) Easily Expandable Platform by Mission Needs'}</p>
                <p>{isKorean ? '고객의 시험 목적과 적용 분야에 맞춰 하드웨어와 소프트웨어 구성을 유연하게 조정할 수 있습니다.' : 'Hardware and software can be flexibly tailored to customer test objectives and operation requirements.'}</p>
              </div>

              <div className="fadeDivide" style={{ marginTop: '24px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img
                  className="astronavFinalImage"
                  src={solutionImg}
                  alt={isKorean ? 'ASTRONAV 시험환경 적용 예시' : 'ASTRONAV test environment application example'}
                />
                <div className="astronavCaption" style={{ textAlign: 'center', marginTop: '8px' }}>
                  {isKorean ? 'ASTRONAV 시험환경 적용 예시' : 'ASTRONAV test environment application example'}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="Exhibition_ASTRONAV">
          <div className="Section">
            <div className="SectionHeaderFull">
              <div className="SectionHeaderTxtbox">
                <div className="SectionHeaderCategory CategoryDark fadeDivide">{isKorean ? '전시회' : 'Exhibition'}</div>
              </div>
            </div>

            <div className="ContentSlider fadeDivide">
              <div className="SliderBg"></div>
              <Slider {...settingsExhibition} className='subSlider'>
                <div className="slider-content">
                  <img className="subSliderImg" src={nidays2026Img1} alt="NIDAYS2026" />
                  <div className="subSliderContents">
                    <div className="subSliderTitle">NIDAYS2026</div>
                    <div className="subSliderTxt"></div>
                  </div>
                </div>
                <div className="slider-content">
                  <img className="subSliderImg" src={nidays2026Img2} alt="NIDAYS2026" />
                  <div className="subSliderContents">
                    <div className="subSliderTitle">NIDAYS2026</div>
                    <div className="subSliderTxt"></div>
                  </div>
                </div>
                <div className="slider-content">
                  <img className="subSliderImg" src={nidays2026Img3} alt="NIDAYS2026" />
                  <div className="subSliderContents">
                    <div className="subSliderTitle">NIDAYS2026</div>
                    <div className="subSliderTxt"></div>
                  </div>
                </div>
                <div className="slider-content">
                  <img className="subSliderImg" src={nidays2026Img4} alt="NIDAYS2026" />
                  <div className="subSliderContents">
                    <div className="subSliderTitle">NIDAYS2026</div>
                    <div className="subSliderTxt"></div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
